<template>
  <div class="industry-option-container">
    <el-card>
      <div class="industry-title-box">
        <div class="title">产业信息</div>
      </div>
      <div class="industry-content-box">

        <div class="row">
          <div class="form-item f-row">
            <div class="form-title">产业名称</div>
            <el-input placeholder="请输入产业名称" v-model="formParams.name" style="width:200px"></el-input>
          </div>

          <div class="form-item f-row">
            <div class="form-title">排列序号</div>
            <el-input placeholder="请输入排列序号" v-model="formParams.indexNum" style="width:200px"></el-input>
          </div>
        </div>

        <div class="row">
          <div class="form-item f-clo">
            <div class="form-title">产业位置</div>
            <Map
              ref="map"
              class="map-box"
              @getInfo="handleGetMap"
              :locationInfo="location"
            ></Map>
          </div>
        </div>

        <div class="row">
          <div class="form-item f-clo">
            <div class="form-title">产业旗下会议室取消规则配置</div>
            <div class="cancel-box">
              <span>会议开始前</span>
              <el-input class="cancel-input" type="number" v-model="formParams.meetingFreeDuration"></el-input>
              <span>小时外可免费取消，时间内取消则扣除</span>
              <el-input class="cancel-input" type="number" v-model="formParams.meetingDeductionRatio"></el-input>
              <span>%支付金额</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-item f-clo">
            <div class="form-title">产业功能</div>
            <div class="industry-function-box">
              <div
                class="fun-item"
                v-for="(item,index) in funList"
                :key="index"
                @click="handleClickFun(item)"
                :class="{'active' : selectFunList.indexOf(item.name) !== -1}"
              >{{item.name}}</div>
            </div>
          </div>
        </div>

        <div class="industry-title-box" v-if="isAchieve">
          <div class="title">第三方信息</div>
        </div>

        <div class="row" v-if="isAchieve">
          <div class="form-item f-clo">
            <div class="form-title">访客预约第三方</div>
            <el-radio-group class="margin-30" v-model="formParams.visitorSupplierType">
              <el-radio :label="0">旗云</el-radio>
              <el-radio :label="1">捷顺</el-radio>
            </el-radio-group>

            <div class="f-row margin-30">
              <div class="title">appid：</div>
              <el-input placeholder="请输入appid" v-model="formParams.visitorSupplierAppId" class="input-class"></el-input>
            </div>

            <div class="f-row margin-30">
              <div class="title">appkey：</div>
              <el-input placeholder="请输入appkey" v-model="formParams.visitorSupplierSecret" class="input-class"></el-input>
            </div>

            <div class="f-row margin-30">
              <div class="title">接口地址：</div>
              <el-input placeholder="请输入接口地址" v-model="formParams.visitorSupplierUrl" class="input-class"></el-input>
            </div>

          </div>
        </div>

        <div class="row" v-if="isAchieve">
          <div class="form-item f-clo">
            <div class="form-title">停车缴费第三方</div>
            <el-radio-group class="margin-30" v-model="formParams.parkingSupplierType">
              <el-radio :label="0">科拓</el-radio>
            </el-radio-group>

            <div class="f-row margin-30">
              <div class="title">appid：</div>
              <el-input placeholder="请输入appid" v-model="formParams.parkingSupplierAppId" class="input-class"></el-input>
            </div>

            <div class="f-row margin-30">
              <div class="title">appkey：</div>
              <el-input placeholder="请输入appkey" v-model="formParams.parkingSupplierSecret" class="input-class"></el-input>
            </div>

            <div class="f-row margin-30">
              <div class="title">packid：</div>
              <el-input placeholder="请输入packid" v-model="formParams.parkingSupplierPackId" class="input-class"></el-input>
            </div>

            <div class="f-row margin-30">
              <div class="title">接口地址：</div>
              <el-input placeholder="请输入接口地址" v-model="formParams.parkingSupplierUrl" class="input-class"></el-input>
            </div>
          </div>
        </div>

        <div class="row" v-if="isAchieve">
          <div class="form-item f-clo">
            <div class="form-title">erp第三方</div>
            <el-radio-group class="margin-30" v-model="formParams.erpSupplierType">
              <el-radio :label="0">明源</el-radio>
            </el-radio-group>

            <div class="f-row margin-30">
              <div class="title">appid：</div>
              <el-input placeholder="请输入appid" v-model="formParams.erpSupplierAppId" class="input-class"></el-input>
            </div>

            <div class="f-row margin-30">
              <div class="title">appkey：</div>
              <el-input placeholder="请输入appkey" v-model="formParams.erpSupplierSecret" class="input-class"></el-input>
            </div>

            <div class="f-row margin-30">
              <div class="title">接口地址：</div>
              <el-input placeholder="请输入接口地址" v-model="formParams.erpSupplierUrl" class="input-class"></el-input>
            </div>
          </div>
        </div>

      </div>
      <div class="industry-btn-box">
        <el-button class="btn" @click="handleReturn">取消</el-button>
        <el-button class="btn" type="primary" @click="handleSubmit">确认</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  getFunList,
  addIndustry,
  getIndustryDetail,
  updateIndustry
} from '@/api/industry'
import globalVariable from '@/configs/index'
import Map from '@/components/Map'
export default {
  data() {
    return {
      inputVal: '',
      formParams: {
        area: '',
        city: '',
        detailsAddress: '',
        province: '',
        erpSupplierAppId: '',
        erpSupplierSecret: '',
        erpSupplierType: '',
        erpSupplierUrl: '',
        functionUuidList: '',
        indexNum: '',
        latitude: '',
        longitude: '',
        name: '',
        parkingSupplierAppId: '',
        parkingSupplierPackId: '',
        parkingSupplierSecret: '',
        parkingSupplierType: '',
        parkingSupplierUrl: '',
        visitorSupplierAppId: '',
        visitorSupplierSecret: '',
        visitorSupplierType: '',
        visitorSupplierUrl: '',
        meetingDeductionRatio: 0,
        meetingFreeDuration: 0,
      },
      funList: [],
      selectFunList: [],
      searchPlace: '',
      isAchieve: false, // 满足条件显示第三方表单
      pageType: 'add',
      marker: null,
      map: null,
      mapKey: globalVariable.mapKey,
      location: [],
      uuid: ''
    }
  },
  mounted() {
    this.location = globalVariable.defaultLocation // 默认地址 安宏基经纬度
    this.formParams.latitude = globalVariable.defaultLocation[0]
    this.formParams.longitude = globalVariable.defaultLocation[1]
    this.init()
  },
  methods: {
    async init(){
      await this.network().getFunList()
      if (this.$route.params.id) {
        this.uuid = this.$route.params.id
        this.pageType = 'edit'
        await this.network().getIndustryDetail(this.$route.params.id)
      }
    },
    network() {
      return {
        getFunList: async() => {
          const { data } = await getFunList()
          console.log(data)
          this.funList = data
        },
        addIndustry: async() => {
          await addIndustry(this.formParams)
          this.$message({
            type: 'success',
            message: '添加成功'
          })
          this.$router.push('/industry-management')
        },
        updateIndustry: async() => {
          let data = {
            ...this.formParams,
            uuid: this.uuid
          }
          await updateIndustry(data)
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.$router.push('/industry-management')
        },
        getIndustryDetail:(id)=>{
          getIndustryDetail(id).then(res=>{
            let data = res.data
            for (let key in data) {
              let val = data[key]
              this.formParams[key] = val
            }

            if (this.formParams.functionUuidList.length !== 0) {
              this.funList.forEach(item => {
                this.formParams.functionUuidList.forEach(label => {
                  if (item.uuid === label) {
                    this.selectFunList.push(item.name)
                  }
                })
              })
            }
            (this.selectFunList.indexOf('访客预约') > -1 && this.selectFunList.indexOf('停车缴费') > -1)
            ? this.isAchieve = true : this.isAchieve = false

            this.location = []
            this.location.push(data.latitude)
            this.location.push(data.longitude)
          })
        }
      }
    },
    handleCheck() {
      const rule = this.formParams
      if (rule.name === '') {
        this.$message.error('请输入产业名称')
        return false
      } else if (rule.indexNum === '') {
        this.$message.error('请输入排序')
        return false
      } else if (rule.latitude === '' || rule.longitude === '') {
        this.$message.error('请选择产业位置')
        return false
      }else if (rule.meetingFreeDuration < 0) {
        this.$message.error('请输入会议室取消规则配置时间')
        return false
      } else if (rule.meetingDeductionRatio < 0) {
        this.$message.error('请输入会议室取消规则配置比例')
        return false
      } else if (rule.functionUuidList.length === 0) {
        this.$message.error('请选择产业功能')
        return false
      } else if (rule.functionUuidList.length === 0) {
        this.$message.error('请选择产业功能')
        return false
      } else if(this.isAchieve){
        if(this.formParams.visitorSupplierType === ''){
          this.$message.error('请选择访客预约第三方')
          return false
        } else if(this.formParams.visitorSupplierAppId === ''){
          this.$message.error('请输入访客预约appid')
          return false
        } else if(this.formParams.visitorSupplierSecret === ''){
          this.$message.error('请输入访客预约appkey')
          return false
        } else if(this.formParams.visitorSupplierUrl === ''){
          this.$message.error('请输入访客预约接口地址')
          return false
        } else if(this.formParams.parkingSupplierType === ''){
          this.$message.error('请选择停车缴费第三方')
          return false
        } else if(this.formParams.parkingSupplierAppId === ''){
          this.$message.error('请输入停车缴费appid')
          return false
        } else if(this.formParams.parkingSupplierSecret === ''){
          this.$message.error('请输入停车缴费appkey')
          return false
        } else if(this.formParams.parkingSupplierPackId === ''){
          this.$message.error('请输入停车缴费packid')
          return false
        } else if(this.formParams.parkingSupplierUrl === ''){
          this.$message.error('请输入停车缴费接口地址')
          return false
        } else if(this.formParams.erpSupplierType === ''){
          this.$message.error('请选择erp第三方')
          return false
        } else if(this.formParams.erpSupplierAppId === ''){
          this.$message.error('请输入erp第三方appid')
          return false
        } else if(this.formParams.erpSupplierSecret === ''){
          this.$message.error('请输入erp第三方appkey')
          return false
        } else if(this.formParams.erpSupplierUrl === ''){
          this.$message.error('请输入erp第三方接口地址')
          return false
        }

      }
      return true
    },
    handleSubmit() {
      if (this.handleCheck()) {
        this.pageType === 'edit' ? this.network().updateIndustry() : this.network().addIndustry()
      }
    },
    handleClickFun(row) {
      if (this.selectFunList.indexOf(row.name) !== -1) {
        this.selectFunList = this.selectFunList.filter(item => item !== row.name)
      } else {
        this.selectFunList.push(row.name)
      }

      (this.selectFunList.indexOf('访客预约') !== -1 && this.selectFunList.indexOf('停车缴费') !== -1) ? this.isAchieve = true : this.isAchieve = false

      this.formParams.functionUuidList = []
      this.selectFunList.forEach(item => {
        this.funList.forEach(lable => {
          if (item === lable.name) {
            this.formParams.functionUuidList.push(lable.uuid)
          }
        })
      })
    },
    handleGetMap(lat, lng, mapInfo){
      this.$message.success('设置成功')
      this.formParams.area = mapInfo.area
      this.formParams.city = mapInfo.city
      this.formParams.province = mapInfo.city
      this.formParams.detailsAddress = mapInfo.detailsAddress
      this.formParams.latitude = lat
      this.formParams.longitude = lng
    },
    handleReturn() {
      this.$router.go(-1)
    }
  },
  components: {
    Map
  }
}
</script>

<style lang="scss" scoped>
.industry-option-container{
  .industry-title-box{
    height: 50px;
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    .title{
      font-size: 20px;
      font-weight: bold;
    }
  }
  .industry-content-box{
    .row {
      display: flex;
      margin-bottom: 60px;
      .f-row{
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }
      .f-clo{
        display: flex;
        flex-direction: column;
        width: 100%;
      }
      .input-class {
        width: 400px;
      }
    }

    .form-item{
      margin-right: 100px;

      .form-title{
        min-width: 100px;
        margin-right: 15px;
        &::before{
          content: "*";
          color: red;
          margin-right: 5px;
        }
      }
      .map-box{
        margin-top: 15px;
        width: 70%;
        height: 600px;
        border: 1px solid #e3e3e3;
        position: relative;
      }

      .search{
        display: flex;
        width: 400px;
        position: absolute;
        top: 10%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 999;
        .input{
          margin-right: 30px;
        }
      }

      .industry-function-box{
        margin-top: 15px;
        display: flex;
        .fun-item {
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          user-select: none;
          border-radius: 5px;
          width: 10%;
          height: 70px;
          margin: 0 5px;
          border: 1px solid #000;
          // background: #169bd5;
          // color: #fff;
        }
        .active{
          background: #169bd5;
          color: #fff;
        }
      }
      .cancel-box{
        display: flex;
        align-items: center;
        margin-top: 30px;
        span{
          display: inline-block;
        }
        .cancel-input{
          max-width: 200px;
          margin: 0 15px;
        }
      }
    }

    .title{
      min-width: 100px;
    }
  }

  .industry-btn-box{
    margin: 60px 0 15px 0;
    width: 100%;
    display: flex;
    justify-content: center;
    .btn{
      margin: 0 15px;
      width: 150px;
    }
  }
}
</style>
